import {
  CartAddRequestRawModel,
  CartEditRequestRawModel,
  CartItemAddRequestRawModel,
  CartItemEditRequestRawModel,
  CartItemExtrasRequestRawModel,
  CartItemRemoveRequestRawModel,
} from '@/api/api-raw-models/cart-request-raw-model';
import {
  CartAddRequestModel,
  CartEditRequestModel,
  CartItemRemoveRequestModel,
  CartItemExtrasRequestModel,
  CartItemEditRequestModel,
  CartItemAddRequestModel,
} from '@/models/CartRequestModel';

/* eslint-disable @typescript-eslint/camelcase */

function mapCartItemExtrasRequest(e: CartItemExtrasRequestModel): CartItemExtrasRequestRawModel {
  return {
    quantity: e.quantity,
    unit_price: e.unitPrice,
    item_extra_list_id: e.itemExtraListId,
    item_extra_list_item_id: e.itemExtraListItemId,
  };
}

function mapCartItemAddRequest(e: CartItemAddRequestModel): CartItemAddRequestRawModel {
  return {
    menu_id: e.menuId,
    menu_item_id: e.menuItemId,
    menu_item_size_id: e.menuItemSizeId,
    note: e.note,
    quantity: e.quantity,
    unit_price: e.unitPrice,
    extras: e.extras.map(mapCartItemExtrasRequest),
  };
}

function mapCartItemEditRequest(e: CartItemEditRequestModel): CartItemEditRequestRawModel {
  return {
    cart_item_id: e.cartItemId,
    new_item: mapCartItemAddRequest(e.newItem),
  };
}

export const mapCartItemRemoveRequest = (e: CartItemRemoveRequestModel): CartItemRemoveRequestRawModel => ({
  cart_item_id: e.cartItemId,
});

export const mapCartAddRequest = (e: CartAddRequestModel): CartAddRequestRawModel => ({
  merchant_id: e.merchantId,
  cart_items: [mapCartItemAddRequest(e.cartItems[0])],
});

export const mapCartEditRequest = (e: CartEditRequestModel): CartEditRequestRawModel => ({
  merchant_id: e.merchantId,
  cart_items: [mapCartItemEditRequest(e.cartItems[0])],
});
